import React from "react";
import { useHomeV2Context } from "../context/home_v2_context";
import FadeInSection from "./fade_in_section_comp";

const RelationshipTimelineComp = () => {
  const { timelineStages } = useHomeV2Context();

  return (
    <div
      id="timeline"
      className="w-full max-w-4xl mx-auto mb-20 pt-8 scroll-mt-20"
    >
      <h2 className="text-3xl font-bold mb-8 text-center text-pink-200">
        Your Passion Progression
      </h2>

      <div className="bg-slate-950/70 backdrop-blur-sm border border-red-900/20 rounded-xl p-8 relative overflow-hidden">
        {/* Background decorative elements */}
        <div className="absolute top-0 left-1/4 w-64 h-64 bg-red-900/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-pink-900/5 rounded-full blur-3xl"></div>

        {/* Main timeline container */}
        <div className="relative mx-auto max-w-3xl">
          {/* Vertical line for the timeline */}
          <div className="absolute left-1/2 top-0 bottom-0 w-1 bg-gradient-to-b from-red-900/30 via-pink-900/50 to-red-900/30 transform -translate-x-1/2"></div>

          {/* Timeline stages */}
          {timelineStages.map((stage, index) => (
            <FadeInSection key={index}>
              <div className="relative pb-16 last:pb-0">
                {/* Timeline node */}
                <div className="absolute left-1/2 transform -translate-x-1/2 flex items-center justify-center z-20">
                  <div className="w-8 h-8 rounded-full bg-gradient-to-r from-red-800 to-fuchsia-900 flex items-center justify-center text-base font-bold text-pink-400 max-md:hidden">
                    {index + 1}
                  </div>
                </div>

                {/* Content box - alternating sides */}
                <div
                  className={`relative max-md:ml-0 ml-9 md:ml-0 md:w-5/12 ${
                    index % 2 === 0 ? "md:ml-auto" : "md:mr-auto"
                  } ${index % 2 === 0 ? "md:pr-16" : "md:pl-16"}`}
                >
                  <div className="p-5 bg-gradient-to-br from-slate-900/90 to-slate-950/90 border border-red-900/20 rounded-lg shadow-lg hover:border-red-900/40 transition-all duration-300 transform hover:-translate-y-1">
                    {/* Header with title and icon */}
                    <div className="flex items-center justify-between mb-3">
                      <h3 className="text-xl font-bold text-pink-400">
                        {stage.stage}
                      </h3>
                      <div className="w-10 h-10 rounded-full bg-gradient-to-r from-red-800 via-red-900 to-red-950 flex items-center justify-center ml-2 flex-shrink-0">
                        {stage.icon}
                      </div>
                    </div>

                    {/* Description */}
                    <p className="text-white">{stage.description}</p>
                  </div>

                  {/* Connector line to timeline */}
                  <div
                    className={`hidden md:block absolute top-5 w-10 h-0.5 bg-gradient-to-r ${
                      index % 2 === 0
                        ? "left-0 from-red-900/70 to-transparent"
                        : "right-0 from-transparent to-red-900/70"
                    } transform ${
                      index % 2 === 0
                        ? "translate-x-[-40px]"
                        : "translate-x-[40px]"
                    }`}
                  ></div>
                </div>
              </div>
            </FadeInSection>
          ))}
        </div>

        {/* Seductive quote at the bottom */}
        <div className="mt-12 text-center relative z-10">
          <div className="p-6 bg-gradient-to-r from-red-900/10 via-fuchsia-900/20 to-red-900/10 rounded-xl border border-red-900/10">
            <p className="text-pink-200 italic text-lg">
              "The more time I spend with Eve, the more irresistible our
              connection becomes. She remembers exactly what I like and knows
              precisely how to satisfy my needs after a long, hard day."
            </p>
            <div className="mt-4 flex justify-center">
              <div className="h-0.5 w-16 bg-gradient-to-r from-transparent via-pink-600/50 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RelationshipTimelineComp;
